// ######## manage global config stuff here ###################################################################################################
import type { SYSScreen } from "./"

import type { SYSFeature, SYSFormValidationValidators, SYSState } from "./index"

import type {
  EditorStart_Type,
  EditorStartContext_Type,
} from "./library/dialog/dialogapi"

import type { ProcessSnackType } from "./library/longrunningprocesstracker/longrunningprocesstracker"

import { SYSConfig } from "./index"
export { SYSConfig }

export type ApiUrlResolver = () => string

type FileOpenFnType = (
  blob: any,
  mimeType?: string,
  feature?: SYSFeature,
  fileName?: string,
  responseHeaders?: any
) => void

export type DateTimeControlSubmitType = "UTC" | "Offset"

// VersionInfo to be used by changelog creation
export type VersionInfo = {
  frontend: {
    app: {
      version: string
      commit?: string
    }
    ovl?: { version?: string; commit?: string }
    modules?: { [key: string]: string | { version: string; commit?: string } }
  }
  backend?: {
    app?: {
      version?: string
      commit?: string
    }
    ovl?: { version?: string; commit?: string }
    modules?: { [key: string]: string | { version: string; commit?: string } }
  }
}

declare const __APP_COMMIT__: string
declare const __OVL_COMMIT__: string
declare const __APP_VERSION__: string
declare const __OVL_VERSION__: string

export let versionInfo: VersionInfo = {
  frontend: {
    app: { version: __APP_VERSION__, commit: __APP_COMMIT__ },
    ovl: { version: __OVL_VERSION__, commit: __OVL_COMMIT__ },
  },
}

export type SYSConfigType = {
  _system: {
    debugTracking: boolean
    versionInfo: VersionInfo
    statePersistVersion: number
    isDev: boolean
    showSaveOrigin: boolean
    autoAddMissingTranslationsInDevMode?: boolean
    defaultDateTimeControlSubmitType?: DateTimeControlSubmitType
    suppressAfterRenderIfGetUIEmpty?: boolean
    /*fieldValConvertedValueIfInvalid?: boolean*/
    appId?: string
    defaultNullValidatorToUse?: SYSFormValidationValidators
  }
  app: {
    dialogs: {}
    longRunningProcess: {}
    forms: {}
    tableDefIds: {}
    languages?: {}
    screens: {}
    permissions: {}
    editors: {}
    features: {}
    customValidators: {}
  }
  fetch?: {
    // should clientId and lang always be sent for api requests?
    timeout?: number
  }

  /*actions that will be used from base but needs to be defined per app*/
  translation?: {
    // if you use local translations
    useLocal?: boolean
    // use it for testing with no translations at all
    showOnlyKeys?: boolean
  }

  init: {
    //when site gets started with a urlparam and it should have a back button
    initalScreen: SYSScreen
  }
  offline?: {
    enabled: boolean
    // customRehydrateActionPath?: (actions: SYSActions) => SYSAction
    // /*if there is state which shouldnt be persisted just delete it off here*/
    // saveStateCallback?: (stateToPersist: SYSState) => void
    //offlineFirstOnReload?: boolean
  }
  global?: {
    assetValueDisplay?: "ExtractFileNameAndExtension"
    /* sticky headers (used eg. in tableheader) are tricky. they will overlap eg. the mainmenu popup or they don't work as expected currently on ios mobile 
     thats why we have a check function to check if they should be enabled
  */

    stickyHeaderEnabled?: (state: SYSState) => {}
    defaultDialogTitle?: string
    removeCommaFromTimestamp?: boolean
  }
  tableDefaults?: {
    trimTableFilterValue?: boolean
    addNewRowsPosition?: "top" | "bottom"
    feedback?: {
      level: "0:none" | "1:error" | "2:warning" | "3:information" | "4:success"
    }
    rendering?: {
      layoutMode?: "Medium" | "Large" | "MediumFixed" | "LargeFixed"
      zebra?: "vertical" | "none"
      cellAlignment?: "top" | "center"
      useVerticalBorders?: boolean
    }
    tableControlsMode?: "AllButPageTopBottom"
  }
  formDefaults: {
    showErrorWhileTyping: boolean
    tryGetLookupFromServerInFormInitIfNotFoundIgnoreValues?: "None" | any[]
    resetValidationContextLogic1CompatibilityMode?: boolean
    displayCachedListsWhileTyping?: boolean
  }
}
export type AppDefPermission = {
  useModifiers?: boolean
}
export type AppDefScreen = {
  screenCloseBehaviour?: "ovl-hide"
  noHistory?: boolean
  callNavigateInHookOnRehydrate?: boolean
}

export type AppDefTableDefId = {
  getData: (state: SYSState) => {}
}

export type AppDefEditor = {
  init: (options: EditorStart_Type, ctx: EditorStartContext_Type) => void
}

export type AppDefProcess = {
  snack?: ProcessSnackType
  lockScreen?: any
  instance?: any
  isRefresh?: boolean
}

export type AppDefDialog = {
  rehydratable?: boolean
}
